
function initOfflineActivationPage ($, $prefix, __) {
    if ($('.' + $prefix + '_my_account_offline_activation').length === 0) {
        // We are not on the offline activation page
        return;
    }

    function bindLicenseDropdown() {
        var licenseSelect = $('#licenseCode');
        var newLicenseCodeContainer = $('#newLicenseCodeContainer');

        licenseSelect.change(function () {
            if (licenseSelect.val() === 'none'){
                newLicenseCodeContainer.show();
            } else {
                newLicenseCodeContainer.hide();
            }
        });
    }

    async function copyToClipboard(text) {
        try {
            await navigator.clipboard.writeText(text);
        } catch (e) {
            console.error(e);

            throw e;
        }
    }

    function bindCopyToClipboard() {
        const copyButton = $('#copyCertificate');
        copyButton.click(async function ($evt) {
            const certTextBox = $('#installationCert');
            if (certTextBox && certTextBox.val()) {
                try {
                    await copyToClipboard(certTextBox.val());

                    const originalText = copyButton.html();
                    copyButton.html('Copied!');

                    setTimeout(function () {
                        copyButton.html(originalText);
                    }, 5000);
                } catch (e) {
                    console.error(e);

                    const originalText = copyButton.html();
                    copyButton.html('Unable to Copy');

                    setTimeout(function () {
                        copyButton.html(originalText);
                    }, 5000);

                }
            }
            })
    }

    bindLicenseDropdown();
    bindCopyToClipboard();
}

export { initOfflineActivationPage };